<script setup>
import PlyrVideo from '@/components/common/PlyrVideo.vue';
import MadeInGermanyIcon from '@/components/icons/MadeInGermanyIcon.vue';
import Tooltip from '~/components/common/Tooltip.vue';

const props = defineProps({
  image: Object,
  imageMetadata: Array,
  index: Number,
  product: Object,
  activeSlideIndex: Number,
});

const tooltipContents = computed(() => {
  return props.imageMetadata?.find((item) => `gid://shopify/ProductImage/${item.id}` === props.image.id) || null;
});

const lightGalleryInstance = inject('lightGalleryInstance');
const plyrVideo = ref(null);

const openInLightGallery = (eventData) => {
  if (lightGalleryInstance.value) {
    // Get current time before pausing
    let currentTime = 0;
    if (plyrVideo.value?.plyr) {
      currentTime = plyrVideo.value.plyr.currentTime;
    }

    // Pause the video in ProductGallery before opening lightgallery
    if (plyrVideo.value) {
      plyrVideo.value.pause();
    }

    lightGalleryInstance.value.openGallery(props.index);

    if (eventData?.shouldAutoplay) {
      setTimeout(() => {
        const videoElement = document.querySelector(
          '.lg-current .lg-video-object video, .lg-current .lg-video video, .lg-current video'
        );
        if (videoElement) {
          // Set the current time from ProductGallery video
          videoElement.currentTime = currentTime;
          videoElement.muted = false;
          videoElement.volume = 1;
          videoElement.play();
        }
      }, 300);
    }
  }
};
</script>

<template>
  <div class="swiper-slide">
    <PlyrVideo
      ref="plyrVideo"
      :src="image.src"
      :alt="image.alt"
      :ratio="0.5625"
      :autoplay="false"
      :muted="false"
      :controls="true"
      @fullscreen-request="openInLightGallery"
    />
    <div class="absolute inset-x-0 bottom-0">
      <MadeInGermanyIcon
        v-if="product.isMadeInGermany && index === 0"
        class="relative z-10 bottom-2 left-2 md:bottom-4 md:left-4"
      />
      <Tooltip v-show="tooltipContents" :contents="tooltipContents" />
    </div>
  </div>
</template>
